import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import useUserState from "../hooks/useUserState";
import useBDocTranslator from "../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "12px 16px",
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  timelineContainer: {
    marginBottom: theme.spacing(2),
  },
  ownAvatar: {
    backgroundColor: theme.palette.primary.main,
  },
  otherAvatar: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function TimelineMessage(props) {
  const classes = useStyles();
  const userState = useUserState();
  const { t } = useBDocTranslator();

  const [replies, setReplies] = useState([]);

  useEffect(() => {
    if (props.messages.thread) {
      setReplies(props.messages.thread);
    }
  }, [props.messages.thread]);

  if (replies.length === 0) {
    return (
      <Box textAlign="center" py={2}>
        <Typography variant="body2" color="textSecondary">
          {t("No replies yet")}
        </Typography>
      </Box>
    );
  }

  return (
    <Timeline align="alternate" className={classes.timelineContainer}>
      {props.messages &&
        replies.map((item) => {
          const date = new Date(item?.createdAt).toLocaleString();
          const mainMessage = props.messages;
          const isOwnMessage = item.send_by_userid === userState[0].user.id;
          return (
            <TimelineItem key={item.id}>
              <TimelineOppositeContent>
                <Typography variant="body2" color="textSecondary">
                  {date}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot
                  color={isOwnMessage ? "primary" : "secondary"}
                  style={{ padding: 0 }}
                >
                  <Avatar
                    style={{ width: 32, height: 32, fontSize: "0.85rem" }}
                    className={
                      isOwnMessage ? classes.ownAvatar : classes.otherAvatar
                    }
                  >
                    {isOwnMessage
                      ? t("You")[0]
                      : (
                          mainMessage?.other_user?.extendedData?.firstName ||
                          "?"
                        )[0]}
                  </Avatar>
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Paper elevation={3} className={classes.paper}>
                  <Typography variant="h6" component="h1">
                    {isOwnMessage
                      ? t("You")
                      : mainMessage?.other_user?.extendedData?.firstName +
                        " " +
                        mainMessage?.other_user?.extendedData?.lastname}
                  </Typography>
                  <Typography>{item?.content}</Typography>
                </Paper>
              </TimelineContent>
            </TimelineItem>
          );
        })}
    </Timeline>
  );
}
